import { useState } from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { localePath } from "../i18n/config";
import { toast } from "react-toastify";
import { AppState } from "../redux/types";
import api from "../utils/api-helper/api";
import { CATEGORIES, categoryOptions } from "../utils/constants";

export default function OrderForm(params: any) {
    const cart = useSelector((state: AppState) => state.cart);
    const templateId = useSelector((state: AppState) => state.categories.category?.attributes.OrderConfirmationNoCardPayer);
    const confirmationEmailId = useSelector((state: AppState) => state.categories.category?.attributes.OrderProcessConfirmationToCustomer);
    const rawCategory = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const category = CATEGORIES[rawCategory as keyof typeof CATEGORIES] || rawCategory;
    const history = useHistory();
    let [btnDisabled, setBtnDisabled] = useState(false);
    const shippingMethods = useSelector((state: AppState) => state.shippingMethods.shipping);
    const shippingMethod = shippingMethods?.find((el) => el.shippingMethod === cart.shippingMethod);
    const placeOrderHandler = () => {
        setBtnDisabled(true);
        const data = {
            name: cart.name,
            address: cart.address,
            postalCode: cart.postalCode,
            city: cart.city,
            country: cart.country,
            email: cart.email,
            mobile: cart.mobile,
            paymentMethod: cart.paymentMethod,
            stripePaymentMethod: cart.stripePaymentMethod,
            price: cart.price,
            shippingPrice: cart.shippingPrice,
            shippingMethod: cart.shippingMethod,
            taxPrice: cart.taxPrice,
            totalPrice: cart.totalPrice,
            products: cart.inCart,
            pickupPoint: cart.pickupPoint?.id || "",
            pickupPointData: cart.pickupPoint,
            usePickupPoint: cart.usePickupPoint,
            coupon: cart.coupon,
            nursingHome: cart.nursingHome,
        };

        const guestOrders = category === categoryOptions.alarm || category === categoryOptions.accessories;

        const endpoint = guestOrders ? (category === categoryOptions.accessories ? "guest-orders/onetime" : "guest-orders") : "orders";
        api.post(`/user/${endpoint}`, { order: data, templateId, shippingMethod, confirmationEmailId })
            .then((resp: any) => {
                if (resp.data.payload.payment_type === "card") {
                    if (resp.data.payload.payment_intent?.status === "requires_action") {
                        window.open(resp.data.payload.payment_intent?.next_action?.redirect_to_url.url, "_self");
                    } else {
                        if (category === categoryOptions.alarm || category === categoryOptions.accessories) {
                            history.push(localePath("thanks"));
                        } else {
                            window.open(`${localePath("tili", "tilaus")}?order_id=${resp.data.payload.order_id}`, "_self");
                        }
                    }
                } else {
                    if (category === categoryOptions.alarm || category === categoryOptions.accessories) {
                        history.push(localePath("thanks"));
                    } else {
                        window.open(`${localePath("tili", "tilaus")}?order_id=${resp.data.payload.order_id}`, "_self");
                    }
                }
            })
            .catch((error) => {
                const body = error.response.data;
                if (body?.message?.type === "StripeInvalidRequestError") {
                    // const message = body?.message?.raw?.message;
                    const message = (
                        <div>
                            <div>Ostoskorissa on ongelma,</div>
                            <Link
                                to={localePath("yhteydenotto")}
                                style={{
                                    color: "#ffffff",
                                    textDecoration: "underline",
                                }}
                            >
                                ota yhteyttä asiakaspalveluun
                            </Link>
                        </div>
                    );
                    toast.error(message, {
                        hideProgressBar: true,
                        position: "bottom-center",
                        theme: "colored",
                    });
                } else if (body?.message?.type === "StripeCardError") {
                    toast.error(body?.message?.raw?.message, {
                        hideProgressBar: true,
                        position: "bottom-center",
                        theme: "colored",
                    });
                } else {
                    toast.error(body?.message, {
                        hideProgressBar: true,
                        position: "bottom-center",
                        theme: "colored",
                    });
                }
            })
            .finally(() => {
                setBtnDisabled(false);
            });
    };

    return (
        <Button type="button" className="btn-block tallenna" disabled={params.disabled || btnDisabled || cart.inCart.length === 0} onClick={placeOrderHandler}>
            Seuraava
        </Button>
    );
}
